var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticClass:"text-h4 red--text"},[_vm._v(" "+_vm._s(_vm.customer.name)+" has open loans and is ineligible for another one. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }